import { LanguageModal } from "@certn/auth/src/LanguageModal";
import { useLanguage } from "@certn/auth/src/hooks/useLanguage";
import { LinkButton, ModalTrigger, Text } from "@certn/cascadia-react";

export function LanguageLink() {
  const { currentLanguageLabel } = useLanguage();
  return (
    <ModalTrigger
      trigger={() => (
        <LinkButton
          leftIcon="language"
          testID="language-selector-link"
          linkStyle="monochrome"
        >
          <Text color="text-weak" style="global/body-secondary-link">
            {currentLanguageLabel}
          </Text>
        </LinkButton>
      )}
    >
      <LanguageModal />
    </ModalTrigger>
  );
}
